import { Row, Typography } from "antd";
import ErrorBG from "assets/images/error-bg.png";
import { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import * as Sentry from "@sentry/react";

const Error: React.FC = () => {
  const error = useRouteError();

  useEffect(() => {
    if (error) {
      console.error("Error occurred:", error);
      Sentry.captureException(error, {
        level: "error",

        extra: {
          location: window.location.href,
          userAgent: navigator.userAgent,
        },
      });
    }
  }, [error]);

  return (
    <div style={{ textAlign: "center" }}>
      <Typography.Title level={3}>
        Sorry we encountered an enforceable error.{" "}
      </Typography.Title>
      <Typography.Text style={{ fontSize: 16 }}>
        Our engineers are already notified and working on the fix.
      </Typography.Text>
      <Row justify="center">
        <img
          src={ErrorBG}
          alt="Error"
          style={{ maxWidth: "100%", height: "auto", margin: "80px 0" }}
        />
      </Row>
    </div>
  );
};

export default Error;
